import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import Logo from './partials/Logo';
// import FooterNav from './partials/FooterNav';
import FooterSocial from './partials/FooterSocial';

//date tine
const current = new Date();
const date = `${current.getFullYear()}-${
  current.getMonth() + 1
}-${current.getDate()}`;
//////////////////////////////////////

const propTypes = {
  topOuterDivider: PropTypes.bool,
  topDivider: PropTypes.bool,
};

const defaultProps = {
  topOuterDivider: false,
  topDivider: false,
};

const Footer = ({ className, topOuterDivider, topDivider, ...props }) => {
  const classes = classNames(
    'site-footer center-content-mobile',
    topOuterDivider && 'has-top-divider',
    className
  );

  return (
    // <footer {...props} className={classes}>
    //   <div className="container">
    //     {' '}
    //     {/* <FooterNav /> */}
    //     <div
    //       className={classNames(
    //         'site-footer-inner',
    //         topDivider && 'has-top-divider'
    //       )}
    //     >
    //       {' '}
    //       <div
    //         className="space-between text-xs"
    //         style={{
    //           textAlign: 'center',
    //           display: 'flex',
    //           // flexDirection: 'row',
    //           // padding: '25px',
    //         }}
    //       >
    //         {' '}
    //         <Logo
    //           style={{
    //             padding: '0px 25px',
    //             // textAlign: 'center',
    //             // justifyItems: 'center',
    //           }}
    //         />
    //         <h6>
    //           info@metalin.eu <h6>+37068404666</h6>
    //         </h6>
    //         <div className="">
    //           {' '}
    //           <div className=" ">
    //             2022 <a href="/">info@metalin.eu</a>
    //             .Visos teisės saugomos
    //           </div>{' '}
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </footer>
    <footer {...props} className={classes}>
      <div className="container">
        <div
          className={classNames(
            'site-footer-inner',
            topDivider && 'has-top-divider'
          )}
        >
          <div
            className="footer-top space-between text-xxs"
            style={{ margin: '0 auto' }}
          >
            <h2>InMetal</h2>
            {/* <Logo
              style={{
                margin: '0 auto',
                display: 'flex',
                textAlign: 'center',
              }}
            />{' '} */}
            <h5 style={{ padding: '15px' }}> info@inmetal.eu</h5>{' '}
            <h6>+370 660 58608</h6> <FooterSocial />
            {/* <FooterSocial /> */}
          </div>
          <div className="footer-bottom space-between text-xxs invert-order-desktop">
            {/* <FooterNav /> */}

            <div
              className="footer-copyright"
              style={{ margin: '0 auto', padding: ' 10px 5px' }}
            >
              <a href="/" style={{ padding: '15px' }}>
                {' '}
              </a>
              <i>MetalIn</i>{' '}
              <i style={{ padding: '8px', fontSize: '12px' }}> {date}</i>{' '}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;
